<template>
    <div class="modelList_box">
        <div class="app_container">
            <div class="modelList_header">
                <ul class="modelList_items">
                    <li  class="modelList_item" id='projectList_item' v-for="(model,index) in showList" v-bind:key="model.id">
                        <div class="modelList_thumbnails project_img_box" v-if="(!model.off_thumb) && model.hasOwnProperty('p_id')" :data='disposeBackguroudPath(model,model.projectThumbnail)' v-bind:style="{'background-image':'url(\'' + disposeBackguroudPath(model,model.projectThumbnail) +'\'),url(../../static/img/scene-default.png)'}" v-on:click="viewScene(model,true)" title="预览项目">
                            <div class="top_left tooltip-box top" data-content="推荐项目" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip" style="background: #f5a726;" v-if="model.tagName=='置顶'">
                                <img src="../../static/img/project.svg"/>
                            </div>
                            <div class="top_left tooltip-box top" data-content="公开项目" @click.stop="viewScene" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip" style="background: #1a8cd8;" v-if="model.tagName==null">
                                <img src="../../static/img/project.svg" />
                            </div>
                            <div class="bottom_left tooltip-box top" data-content="预览场景" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip" @click.stop="viewScene(model,true)" title="">
                                <i class="fa fa-search tooltip-box top" data-content="预览场景" style="font-size:1.2em;"></i>
                            </div>
                            <div class="bottom_left tooltip-box top" data-content="查看源码" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip" @click.stop="editScene(model)" style="left:56px;" v-if="!queryData.isAPP && model.isOpen!='1'" title="">
                                <i class="fa fa-edit tooltip-box top" data-content="查看源码" style="font-size:1.5em;display: inline-block;margin-top: 3px;margin-left: 2px;"></i>
                                <div class="tooltips"><div class="arrow"></div>查看源码</div>
                            </div>
                            <span class="indexAPP" @click.stop="viewScene"><i>{{index+1}}</i></span>
                            <div id="model_keyword">
                                <ul>
                                    <li v-html="$options.filters.highLightkeyWord(keyword)" v-if="$options.filters.highLightkeyWord(keyword)" v-for="(keyword) in model.keyWordArr" v-bind:key="keyword">{{keyword}}</li>
                                </ul>
                            </div>
                            <div class="isPay" v-if="model.isShopping==1 ||
                                                (model.isTemplate == 1 && model.terff != 0 && model.torder)"
                                                @click.stop="saleItem(model)">
                                购买
                            </div>
                        </div>
                        <div class="modelList_thumbnails project_img_box" v-if="model.off_thumb && model.hasOwnProperty('p_id')" v-bind:style="{'background-image':'url(\''+ disposeBackguroudPath(model,model.off_thumb) +'\'),url(../../static/img/scene-default.png)'}" v-on:click="viewScene(model,true)" title="预览项目">
                            <div class="top_left tooltip-box top" data-content="推荐项目" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip" style="background: #f5a726;" v-if="model.tagName=='置顶'">
                                <img src="../../static/img/project.svg"/>
                            </div>
                            <div class="top_left tooltip-box top" data-content="公开项目" @click.stop="viewScene" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip" style="background: #1a8cd8;" v-if="model.tagName==null">
                                <img src="../../static/img/project.svg" />
                            </div>
                            <div class="bottom_left tooltip-box top" data-content="预览场景" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip" @click.stop="viewScene(model,true)" title="">
                                <i class="fa fa-search tooltip-box top" data-content="预览场景" style="font-size:1.2em;"></i>
                            </div>
                            <div class="bottom_left tooltip-box top" data-content="查看源码" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip" @click.stop="editScene(model)" style="left:56px;" v-if="!queryData.isAPP && model.isOpen!='1'" title="">
                                <i class="fa fa-edit tooltip-box top" data-content="查看源码" style="font-size:1.5em;display: inline-block;margin-top: 3px;margin-left: 2px;"></i>
                                <div class="tooltips"><div class="arrow"></div>查看源码</div>
                            </div>
                            <span class="indexAPP" @click.stop="viewScene"><i>{{index+1}}</i></span>
                            <div id="model_keyword">
                                <ul>
                                    <li v-html="$options.filters.highLightkeyWord(keyword)" v-if="$options.filters.highLightkeyWord(keyword)" v-for="(keyword) in model.keyWordArr" v-bind:key="keyword">{{keyword}}</li>
                                </ul>
                            </div>
                            <div class="isPay" v-if="model.isShopping==1
                                                || (model.isTemplate == 1 && model.terff != 0 && model.torder)"
                                                @click.stop="saleItem(model)">
                                购买
                            </div>
                        </div>
                        <div class="modelList_thumbnails project_img_box"  style="overflow: hidden;" v-if="!model.hasOwnProperty('p_id')"
                            @click="clickImgBg(model, true)"
                            :style="{'background-image' : 'url(\'' + model.img + '\'),url(../../static/img/scene-default.png)' }">
                            <span class="recommand"><span class="recommand_label"></span></span>
                            <span class="indexAPP" @click.stop="viewScene"><i>{{index+1}}</i></span>
                        </div>
                        <div class="modelList_info projectList_info" v-if="!model.hasOwnProperty('p_id')">
                            <div class="author_info shop_author_info">
                                <a class="tooltip-box top">
                                    <img class="author_headImg scene_author_headImg" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAAXNSR0IArs4c6QAAAU1QTFRFAAAA/////6o5/5VA/5c6/5I6/484/Y84/Y82/Y83/Y43/Y42/I82/I83/Y82/Y42/Y83/Y43/Y83/Y82/I42/I43/I85/JA5/JE7/JE8/JE9/JI+/JM//JRB/JVE/JZE/JZF/JdG/JhI/JlJ/JlK/JpM/JtN/JxP/J1S/J5T/KBX/KFY/KFZ/KNc/KRe/Kdj/Kpp/Ktq/Kxs/K1t/K5v/LF0/LF1/bN5/bR7/bV8/biB/buH/byJ/b6L/cCP/cOU/cSW/cSX/cid/cie/cyk/c+p/dCr/dGu/dKv/dSy/da2/da3/de4/tm8/tq9/tu//tzB/t7E/t/G/t/H/uHK/uPN/uPO/ubS/ufV/ufW/ujX/urZ/uvc/uvd/uze/u/k/vDk/vTs/vXu/vbw/vfx/vjz/vn0/vn1/vr2/vv5/vz6/v38/v79/v7+////xH9XNgAAABR0Uk5TAAEJDBYjUnJ/goOlqr/T2ejy8/4s5yf1AAABnUlEQVQ4y5WVWVvTYBCFB5qSlK6kr6CIbKbILuICuFZacCsqlF1AEXABnP9/yUVDrdBlfK/yPDn55pnzzZyI/EPUjSfTvp9Oxt2oNMSJpaghFXPqyiKezxV8L3Jd15GhDpmOK7I2L0tdsl5bra49QUMS7TXnNdFB4u+ZHk3xqn1kmwuzYUeRDC3IRCyFq8Udv7XQd0SkEwMxEUlZhCmRKCai4jZ8N/C8B8g9BMCVeD1Nrg9gfoQbTOUAiEsSgJX7AIUp3izBwqH+KY/A4Mq5Hj2tfJqUNAD6CRjX2WEt8Ui/5d+e7d9kQz8WvuoTANJScVE/AxM6G2iJzZ93Ia9zt7UI/d+3K05KFwC/y8C0zgRa4mQDmNTFAX0ArP4AoCssvXPcD691PNASp2VgTIt9WoA7h7th6Uozc3rwcvlsrzvQD5yuAaNaZOv83at9XQibCe15dqK6fo+hgxm+PAZ4nycoq/56QWhP1fBb3df97Om9fHLtV2geColZx8w8uOZVsC+XeV3tAWCPFHNI2WPPHqT/Ec0i4nSawr7F7+MCX2CBaiy/Id0AAAAASUVORK5CYII="/>
                                </a>
                                <span class="author_name no-effect">{{ model.name }}</span>
                            </div>
                        </div>
                        <hr/>
                        <div class="modelList_info projectList_info" v-if="model.hasOwnProperty('p_id')">
                            <div class="author_info project_author_info">
                                <a class="tooltip-box top" style = "cursor:auto">
                                    <img class="author_headImg" v-bind:src="disposeUrl(model.userNick,model.imgurl)?disposeUrl(model.userNick,model.imgurl):'../../static/img/thingjslogo.png'" onerror="src='../../static/img/thingjslogo.png'"/>
                                </a>
                                <span class="author_name" v-html="$options.filters.highLightMsg(model.projectName)" v-bind:title="model.projectName" @dblclick="selectText()">{{model.projectName}}</span>
                            </div>
                            <div class="model_info">
                                <div class="model_seen model_time tooltip-box top"  v-bind:data-content="convertUTCTimeToLocalTime(model.cTime)" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip">
                                    <i class="fa fa-calendar fa-fw"></i>
                                </div>
                                <div class="model_seen tooltip-box top" data-content="资源参考值" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip">
                                    <i class="fa fa-file-archive-o"></i>{{formatBytes(model.projectSize)}}
                                </div>
                                <div class="model_seen tooltip-box top" data-content="浏览次数" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip">
                                    <i class="fa fa-eye fa-fw"></i>{{formatNumber(model.likeNum)}}
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="modelList_footer">
                <h4 class="text_muted" v-if="!isLoadComplete">加载中...</h4>
				<div class="load_more_btn" v-on:click="loadMore" v-if="!isLastPage&&isLoadComplete">加载更多<i class="fa fa-arrow-circle-o-down"></i></div>
				<h4 v-if="isLastPage" class="text_muted">已显示全部</h4>
			</div>
            <thingjs-x-pop-up v-if="popupshow" :propContent = propContent @cancel="cancelClick($event)"></thingjs-x-pop-up>
        </div>
    </div>
</template>

<script>
    import bus from '../assets/js/eventBus.js';
    import crypto from 'crypto-browserify';
    import Identicon from 'identicon.js';
    import shield from '../assets/js/shield.js';
    import thingjsXPopUp from './thingjs-x/thingjsXPopUp.vue';
    var vm;
    export default {
        nanme:"projectList_box",
        data:function(){
            return{
                Path: "https://www.thingjs.com",
                otherPath:"http://www.thingjs.com",
                projectPath: "http://www.thingjs.com/guide/sampleindex.html?m=",
                editProjectPath:"https://www.thingjs.com/guide/?m=sample&o=",
                chartProjectPath: "https://www.thingjs.com/chart/publish/",
                showList:[],
                queryData: {
					type:"projectList",
					bigType: "",
					smallType: "",
					keyWord: "",
					pageSize: 24,
					pageNumber: 1,
                    sort: "zonghe",
                    isAPP:false
                },
                ignore:['1642682536e64ff3','1642682269672180','164268251123fdb8','1642682488bb6cfa','16497468865f7907'], //不显示购买
                isLastPage:false,
                message:[],
                isLoadComplete :false,
                panelShow:false,
                isZeroData:false,
                totalCount:0,
                propContent: {
                    clickImgBgUrl:'',
                    title:''
                },
                popupshow: false
            }
        },
        components: {
            thingjsXPopUp
        },
        beforeCreate() {
            vm = this;
        },
        methods:{
            selectText(){
                document.getSelection().selectAllChildren(document.getSelection().focusNode.parentNode);
                document.execCommand('copy');
            },
            isEmpty:function (obj){
                if(typeof obj == "undefined" || obj == null || obj == ""){
                    return true;
                }else{
                    return false;
                }
            },
            disposeUrl:function(userNick,url){
                if(this.isEmpty(userNick)){
                    userNick = 'thingjs';
                }
                if(this.isEmpty(url)){
                    var hash = crypto.createHash('md5');
                    hash.update(userNick);
                    var imgData = new Identicon(hash.digest('hex')).toString();
                    var imgUrl = 'data:image/png;base64,'+imgData;
                    return imgUrl;
                }else{
                    var urlHeader = url.substring(0,4);
                    if(urlHeader == 'http'){
                        return url;
                    }else{
                        return this.Path + this.encodeAno(url);
                    }
                }
            },
            formatBytes:function(bytes, decimals) {
                if (bytes === 0) return ' -- ';
                var k = 1024;
                var dm = decimals < 0 ? 0 : decimals;
                var sizes = ['B', 'K', 'M', 'G', 'T', 'PB', 'EB', 'ZB', 'YB'];
                var i = Math.floor(Math.log(bytes) / Math.log(k));
                return ' ' + parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + sizes[i];
            },
            disposeBackguroudPath:function(model,url){
                if(this.isEmpty(url)){
                    return false;
                }else{
                    var urlHeader = url.substring(0,4);
                    if(urlHeader == 'http'){
                        if(model.projectName=='my'){
                            return false;
                        }else{
                            return encodeURI(url);
                        }
                    }else{
                        return this.Path + url;
                    }
                }
            },
            disposeBackguroudUrl:function(url){
                if(this.isEmpty(url)){
                    return false;
                }else{
                    var urlHeader = url.substring(0,4);
                    if(urlHeader == 'http'){
                        if(this.validateImage(url)){
                            return url;
                        }else{
                            return '../../static/img/scene-default.png';
                        }
                    }else{
                        if(this.validateImage(this.Path + this.encodeAno(url))){
                            return this.Path + this.encodeAno(url);
                        }else{
                            return '../../static/img/scene-default.png';
                        }
                    }
                }
            },
            validateImage:function (url){
                var xmlHttp ;
                if (window.ActiveXObject){
                    xmlHttp = new ActiveXObject("Microsoft.XMLHTTP");
                }else if (window.XMLHttpRequest){
                    xmlHttp = new XMLHttpRequest();
                }
                xmlHttp.open("Get",url,false);
                xmlHttp.send();
                if(xmlHttp.status==404){
                    return false;
                }else{
                    return true;
                }
            },
            disposeProjectUrl:function(data){
                if(this.isEmpty(data.projectJs)){
                    return false;
                }else{
                    var urlHeader =data.projectJs.substring(0,4);
                    if(urlHeader == 'http'){
                        return data.projectJs;
                    }else{
                        if(data.link){
                            if(data.browseType &&data.browseType =='http'){
                                var newPath = data.projectJs.indexOf('/project/')>0?this.otherPath +"/p/":this.otherPath +"/pp/";
                                // console.log(newPath +　data.link,1)
                                return newPath +　data.link;
                            }else{
                                var newPath = data.projectJs.indexOf('/project/')>0?this.Path +"/p/":this.Path +"/pp/";
                                // console.log(newPath +　data.link,2)
                                return newPath +　data.link;
                            }
                        }else{
                            var newurl = data.projectJs.substr(1);
                            return this.projectPath + this.encodeAno(newurl);
                        }
                    }
                }
            },
            showTooltip: function(event) {
				var content = $(event.target).data("content");
				var tipEle ='<div class="tooltips"><div class="arrow"></div>' + content +'</div>';
				$(event.target).append(tipEle);
			},
			cancelTooltip: function(event) {
				$("div").remove(".tooltips");
            },
            showTooltip1: function(event) {
                var content = $(event.target).data("content");
                var tipEle ='<div class="tooltips"><div class="arrow"></div>' + content +'</div>';
                $(event.target).append(tipEle);
                var leftPx = Number('-' + parseInt($('.tooltips').width())/2);
                $('.projectList_info .project_author_info .top .tooltips').css({
                    "left":leftPx,
                    "transition-duration":"0s"
                });
            },
            cancelTooltip1: function(event) {
                $("div").remove(".tooltips");
                $('.projectList_info .project_author_info .top .tooltips').css({
                    "left":"0px",
                    "transition-duration":"0s"
                });
            },
			formatNumber: function(number) {
				if(number < 1000) {
					return number;
				} else {
					return(number / 1000).toFixed(1) + "k";
				}
            },
            loadMore: function() {
                this.queryData.pageNumber++;
                this.queryModelList(this.queryData);
            },
            encodeAno:function (a) {
                a = encodeURI(a);
                return a.substr(0, a.lastIndexOf('/')) + a.substr( a.lastIndexOf('/')).replace(/0/g, '02').replace(/%/g, '01');
            },
            queryModelList:function(data){
                var _this = this;
                var _list = this.showList;
                _this.isLoadComplete = true;
				this.$reqs.post("/scene/project", data).then(function(result) {
                    if(result.data && result.data.state) {
                        _this.isZeroData = (result.data.content.totalPage)?true:false;
                        var content = result.data.content.rows;
                        var contentLen = content.length;
                        bus.$emit('changeListCount',result.data.content.count);
                        for(var i = 0; i < contentLen; i++) {
                            if(content[i].p_id&&(_this.ignore.indexOf(content[i].p_id)!=-1)) content[i].isShopping=0;
                            if(_this.isZeroData) {
                                content[i].id='z_'+content[i].id
                            }
                            _list.push(content[i]);
                        }
                        if(!_this.isZeroData) {
                            _this.isLastPage = result.data.content.count <= data.pageNumber*data.pageSize;
                        }
                        
                    }else{
                       console.log('queryProjectList error');
                    }
                }).catch(function(error) {
                    console.log('queryProjectList error'+error);
                });
            },
            viewScene:function(data,flag){
                if(flag){
                    var msg = {title:'预览项目',subject:'prjList',toolInfo:{data:data}};
                    bus.$emit('view',msg);
                    return
                }
                window.AnalysysAgent && window.AnalysysAgent.track('ResourcesCenter_Click', {
                    resources: '项目',
                    type:'项目',
                    projectName: data.projectName,
                    projectID: data.id + ''
                })
                if($.cookie('openid')){
                    if(this.disposeProjectUrl(data)){
                        var openUrl = "";
                        if(data.chartId == "undefined" || data.chartId == null || data.chartId == ""){
                            openUrl = this.disposeProjectUrl(data);
                        }else {
                            openUrl = this.chartProjectPath + data.chartId;
                        }
                        this.$reqs.get("/project/addProjectViewCount?viewId="+encodeURIComponent(data.projectJs), {}).then(function(result) {
                            window.open(openUrl,"_blank");
                        }).catch(function(error) {
                            window.open(openUrl,"_blank");
                            console.log(error);
                        });
                    }else{
                        console.log('暂时无法预览');
                    }
                }else{
                   logoinForStore();
                }
            },
            editScene:function(data){
                if($.cookie('openid')){
                    if(data.isOpen=='1'){
                        console.log('暂时无法编辑');
                        return;
                    }else{
                        var urlHeader =data.isOpen.substring(0,4);
                        if(urlHeader == 'http'){
                            window.open(data.isOpen,"_blank");
                        }else{
                            var openUrl = this.editProjectPath + data.isOpen;
                            window.open(openUrl,"_blank");
                        }
                    }
                }else{
                   logoinForStore();
                }
            },
            convertUTCTimeToLocalTime: function(UTCDateString) {
				if(!UTCDateString) {
					return this.message.createTime;
				}
				function formatFunc(str) {
					return str > 9 ? str : '0' + str
				}
				var date2 = new Date(UTCDateString);
				var year = date2.getFullYear();
				var mon = formatFunc(date2.getMonth() + 1);
				var day = formatFunc(date2.getDate());
				var hour = date2.getHours();
				var sec = date2.getSeconds();
				hour = formatFunc(hour);
				sec = formatFunc(sec);
				var min = formatFunc(date2.getMinutes());
				var dateStr = year + '-' + mon + '-' + day + ' ' + hour + ':' + min + ':' + sec;
				return dateStr;
            },
            isMobile() {
                let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
                return flag;
            },
            saleItem(data,flag = true) {
                // console.log('购买项目3')
                if(flag){
                    var msg = {title:"购买项目",subject:'project_buy_projectList',toolInfo:{data:data}};
                    bus.$emit('view',msg);
                    return
                }
                if($.cookie('openid')){
                    if(data.isTemplate == 1 && data.terff != 0 && data.torder){
                        // var tOrderId='14327.ThingJS_Template.104'
                        var tOrderId = $.cookie('mmdId') + ".ThingJS_Template." + data.torder;
                        layer.open({
                            type: 2,
                            title: false,
                            closeBtn: 0,
                            area: ['585px', '568px'],
                            content: [
                                window.location.protocol+'//www.thingjs.com/static/payment/createPay/paymentOrder.html?type=ThingJS_Template&userId=' +
                                $.cookie('mmdId') + '&tOrderId=' + tOrderId, 'no'
                            ],
                            skin: 'buyModelDiv',
                            success:function(){
                                document.getElementsByClassName('buyModelDiv')[0].querySelector('.layui-layer-content').children[0].contentWindow.postMessage({paySource:location.href}, '*');
                            }
                        });
                        window.addEventListener('message', function (event) {
                            if(event.data&&event.data.type&&event.data.type=="newStyle") {
                                $(".buyModelDiv").css({"border-radius":"8px","background-color": "transparent"});
                                $(".buyModelDiv iframe").css("border-radius","8px");
                            }
                            if (event.data == 'close') {
                                layer.closeAll();
                            }
                        })
                    }else{
                        // var tOrderId = $.cookie('mmdId') + ".ThingJS_ForProject." + data.p_id;
                        // // console.log(data.p_id,111)
                        // layer.open({
                        //     type: 2,
                        //     title: false,
                        //     closeBtn: 0,
                        //     area: ['535px', '558px'],
                        //     content: [
                        //         'http://www.thingjs.com/static/payment/createPay/paymentOrder.html?type=ThingJS_Template&userId=' +
                        //         $.cookie('mmdId') + '&tOrderId=' + tOrderId, 'no'
                        //     ],
                        //     skin: 'buyModelDiv',
                        // });
                        // window.addEventListener('message', function (event) {
                        //     if (event.data == 'close') {
                        //         layer.closeAll();
                        //     }
                        // })

                        // this.panelShow = true;
                        var name = data.projectName?data.projectName:data.name
                        var msg = {
                            "subject":'saleProject',
                            "projectName":"购买项目："+name,
                            type:'ThingJS_ForProject',
                            id:data.p_id
                        }
                        if(this.disposeProjectUrl(data)){
                            var openUrl = "";
                            if(data.chartId == "undefined" || data.chartId == null || data.chartId == ""){
                                openUrl = this.disposeProjectUrl(data);
                            }else {
                                openUrl = this.chartProjectPath + data.chartId;
                            }
                            this.$reqs.get("/project/addProjectViewCount?viewId="+encodeURIComponent(data.projectJs), {}).then(function(result) {
                                msg.url = openUrl;
                                bus.$emit("sales",msg);
                                // window.parent.postMessage({"type":"saleProject","msg":msg},'*');
                            }).catch(function(error) {
                                msg.url = openUrl;
                                bus.$emit("sales",msg);
                                // window.parent.postMessage({"type":"saleProject","msg":msg},'*');
                                console.log(error);
                            });
                        }else{
                            msg.url='';
                        }
                    }
                }else{
                   logoinForStore();
                }
            },
            clickImgBg(data, flag){
                if(flag){
                    var msg = {title:'预览插件',subject:'thingx-plugin',toolInfo:{data:data}};
                    bus.$emit('view',msg);
                    return
                }
                this.propContent.clickImgBgUrl = data.preview;
                this.propContent.title = data.name;
                this.popupshow = true;
                document.documentElement.style.cssText = 'overflow:none;';
                document.body.style.cssText = 'overflow:hidden;padding:0 17px 0 0;';
            },
            cancelClick(val){
                this.popupshow = val;
            },
            hidePanel:function(success) {
                var _this = this;
                this.panelShow = false;
            },
        },
        beforeDestroy () {
            bus.$off("addProjectlList");
            bus.$off("changeProjectList");
            bus.$off("showProjectNull");
        },
        mounted(){
            var _this = this;
            if(shield.shieldWords.indexOf($("#keyword").val())=='-1'){
                this.queryData.keyWord = $("#keyword").val();
            }
            this.queryData.sort = $('.active').attr('data-sort');
            this.queryModelList(this.queryData);
            bus.$on("showProjectNull",(data) =>{
                this.showList = [];
                bus.$emit('changeListCount','-1');
                this.isLastPage = true;
            });
            bus.$on("changeProjectList",(data) =>{
                this.showList = [];
                this.queryModelList(data);
                this.queryData = JSON.parse(JSON.stringify(data));
            });
            bus.$on("addProjectlList", (data) => {
                _this.queryData.pageNumber++;
                this.queryModelList(_this.queryData);
            });
            bus.$on("prjList",(data) => {
                this.viewScene(data,false);
            })

            // shopScenes.vue购买留资拦截
            bus.$on("project_buy_projectList",(data) => {
                // console.log('project_buy_projectList')
                this.saleItem(data,false);
            })
            bus.$on("thingx-plugin",(data) => {
                this.clickImgBg(data,false);
            })
            if (_this.isMobile()) {
                this.queryData.isAPP = true;
            } else {
                this.queryData.isAPP = false;
            }
        },
        filters:{
            highLightMsg:function(value){
                if(vm.queryData && vm.queryData.keyWord){
                    var reg = new RegExp(vm.queryData.keyWord,"g");
                    if(value.indexOf(vm.queryData.keyWord) != -1){
                        return value.replace(reg,'<span class="highlight">'+vm.queryData.keyWord+'</span>')
                    }else{
                        return value;
                    }
                }else{
                    return value ;
                }
            },
            highLightkeyWord:function(value){
                if(vm.queryData && vm.queryData.keyWord){
                    var reg = new RegExp(vm.queryData.keyWord,"g");
                    if(value.indexOf(vm.queryData.keyWord) != -1){
                        return value.replace(reg,'<span class="highlight">'+vm.queryData.keyWord+'</span>')
                    }else{
                        return false;
                    }
                }else{
                    return false;
                }
            }
        }
    }
</script>

<style>
.modelList_box .recommand {
    position: absolute;
    border-top: 40px solid transparent;
    border-right: 40px solid transparent;
    border-left: 40px solid transparent;
    border-bottom: 40px solid #ff7f29;
    transform: rotate(315deg);
    content: "零代码";
    left: -40px;
    top: -40px;
}
.modelList_box .recommand:after {
    position: absolute;
    top: 17px;
    right: -23px;
    content: "零代码";
    width: 40px;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/ProjectList.vue